export default __webpack_public_path__ + "images/referenzen/werbespot/tvc_nline_netflix_gilmore_girls_season8.mp4";